const index = () => {};

export default index;
